__turbopack_context__.v({
  "className": "outfit_683a9d73-module__q8J6Eq__className",
  "variable": "outfit_683a9d73-module__q8J6Eq__variable",
});
